import { I18n } from '@app/i18n/strings-keys';

export enum EVENT_STATUS_VALUE {
  Open = 'open',
  Closed = 'closed',
  Pending = 'pending',
  Canceled = 'canceled',
  Completed = 'completed',
}

export const EVENT_STATUS_TEXT_MAPPING = {
  [EVENT_STATUS_VALUE.Open]: I18n.Status.open,
  [EVENT_STATUS_VALUE.Closed]: I18n.Status.closed,
  [EVENT_STATUS_VALUE.Pending]: I18n.Status.pending,
  // may be these two status values are not used, but maybe previously they are existed,
  [EVENT_STATUS_VALUE.Canceled]: I18n.Status.canceled,
  [EVENT_STATUS_VALUE.Completed]: I18n.Status.completed,
};

export const EVENT_STATUS_LABEL_TEXT_MAPPING = {
  [EVENT_STATUS_VALUE.Open]: I18n.Status.Open,
  [EVENT_STATUS_VALUE.Closed]: I18n.Status.Closed,
  [EVENT_STATUS_VALUE.Pending]: I18n.Status.Pending,
};
